import { Translation as T } from "@awe-web/shared/lib";
import PropTypes from "prop-types";
import React from "react";
import { Col, Row } from "../../../components/grid.js";

const DELIVERY_MAIL_LABEL = "ALG0000149";
const DELIVERY_MAIL_TEXT = "ALG0000150";
const DELIVERY_E_MAIL_LABEL = "ALG0000151";

export default function BillDeliveryReadOnly({billDeliveryType, email}) {

  return billDeliveryType === "MAIL"
    ? (
      <Row>
        <Col desktop={{ cols: 8, offset: 2 }}>
          <T className="b2b-payment__radiobutton__label" code={DELIVERY_MAIL_LABEL} />
          <T className="b2b-payment__radiobutton__text" code={DELIVERY_MAIL_TEXT} />
        </Col>
      </Row>
    )
    : (
      <Row>
        <Col desktop={{ cols: 8, offset: 2 }}>
          <T className="b2b-payment__radiobutton__label" code={DELIVERY_E_MAIL_LABEL} />
          {email}
        </Col>
      </Row>
    );
}

BillDeliveryReadOnly.propTypes = {
  billDeliveryType: PropTypes.oneOf(["MAIL", "EMAIL"]),
  email: PropTypes.string
};
